export default __webpack_public_path__ + "static/media/history-icon.1e609d0d.svg";